import { atom } from 'jotai';

export const uiStateAtomSearchModalOpened = atom(false);
